const EMAIL_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

customElements.define('custom-main-login', class extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // Helper function to toggle all temp buttons
    const toggleTempButtons = (hide) => {
      const tempButtons = this.querySelectorAll('.temp_button');
      tempButtons.forEach(btn => {
        if (hide) {
          btn.classList.add('hide_temp_button');
        } else {
          btn.classList.remove('hide_temp_button');
        }
      });
    };

    // ContactForm-checkbox4 이벤트 리스너
    const checkbox4 = this.querySelector('#ContactForm-checkbox4');
    if (checkbox4) {
      checkbox4.addEventListener('change', (e) => {
        if (e.target.checked) {
          localStorage.setItem('emailYN', 'Y');
        } else {
          localStorage.setItem('emailYN', 'N');
        }
      });
    }

    // ContactForm-checkbox1 이벤트 리스너
    const checkbox1 = this.querySelector('#ContactForm-checkbox1');
    if (checkbox1) {
      checkbox1.addEventListener('change', (e) => {
        const checkbox2 = this.querySelector('#ContactForm-checkbox2');
        const agreement = this.querySelector('#agreement');
        const agreementError = agreement ? agreement.querySelector('.form-field__text--error') : null;

        if (e.target.checked) {
          if (agreementError) agreementError.classList.add('hidden');

          if (checkbox2 && checkbox2.checked) {
            toggleTempButtons(true);
          } else {
            toggleTempButtons(false);
          }
        } else {
          toggleTempButtons(false);
          if (agreementError) agreementError.classList.remove('hidden');
        }
      });
    }

    // ContactForm-checkbox2 이벤트 리스너
    const checkbox2 = this.querySelector('#ContactForm-checkbox2');
    if (checkbox2) {
      checkbox2.addEventListener('change', (e) => {
        const checkbox1 = this.querySelector('#ContactForm-checkbox1');
        const privacy = this.querySelector('#privacy');
        const privacyError = privacy ? privacy.querySelector('.form-field__text--error') : null;

        if (e.target.checked) {
          if (privacyError) privacyError.classList.add('hidden');

          if (checkbox1 && checkbox1.checked) {
            toggleTempButtons(true);
          } else {
            toggleTempButtons(false);
          }
        } else {
          toggleTempButtons(false);
          if (privacyError) privacyError.classList.remove('hidden');
        }
      });
    }

    // Reset 버튼 이벤트 리스너
    const resetButton = this.querySelector('#reset');
    if (!resetButton) {
      console.warn('Reset button (#reset) not found');
      return;
    }

    resetButton.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('🔍 [Password Reset] Send 버튼 클릭됨');
      
      const resetPasswordWrapper = this.querySelector('.recover');
      const email = resetPasswordWrapper.querySelector('#RecoverEmail');
      // data 속성을 가진 p 태그를 명확하게 선택
      const errorMsg = resetPasswordWrapper.querySelector('p[data-email-missing-at]');
      const formFieldWrapper = resetPasswordWrapper.querySelector('.form-field__wrapper');
      
      if (!email || !errorMsg) {
        console.error('❌ [Password Reset] 요소를 찾을 수 없습니다:', {
          email: !!email,
          errorMsg: !!errorMsg,
          resetPasswordWrapper: !!resetPasswordWrapper
        });
        return;
      }
      
      const emailValue = email.value.trim();
      console.log('📧 [Password Reset] 입력된 이메일:', emailValue || '(빈 값)');
      
      // 이메일 유효성 검사 - 세 가지 케이스로 분리
      if (!emailValue) {
        // 빈 값 체크
        const errorText = '* Email cannot be empty.';
        console.warn('⚠️ [Password Reset] CASE 0: 빈 값 -', errorText);
        errorMsg.innerText = errorText;
        errorMsg.classList.remove('hidden');
        if (formFieldWrapper) formFieldWrapper.classList.add('form-field__wrapper--error');
        return;
      }
      
      // CASE 1: @를 입력하지 않을 경우
      if (!emailValue.includes('@')) {
        // 메시지: "Please enter the part after '@'. '{Email 영역에 입력한 텍스트}' is incomplete."
        const errorText = errorMsg.dataset.emailIncompleteAfterAt 
          ? errorMsg.dataset.emailIncompleteAfterAt.replace('{{ email }}', `'${emailValue}'`)
          : `Please enter the part after '@'. '${emailValue}' is incomplete.`;
        const finalErrorText = `* ${errorText}`;
        console.warn('⚠️ [Password Reset] CASE 1: @ 없음 -', finalErrorText);
        errorMsg.innerText = finalErrorText;
        errorMsg.classList.remove('hidden');
        if (formFieldWrapper) formFieldWrapper.classList.add('form-field__wrapper--error');
        return;
      }
      
      // @가 포함된 경우, 앞뒤 부분 체크
      const emailParts = emailValue.split('@');
      const beforeAt = emailParts[0] ? emailParts[0].trim() : '';
      const afterAt = emailParts.length > 1 ? emailParts[1].trim() : '';
      
      console.log('🔍 [Password Reset] 이메일 분석:', {
        beforeAt,
        afterAt,
        emailParts
      });
      
      // CASE 2: @ 앞부분을 입력하지 않을 경우 (예: '@test.com')
      if (!beforeAt || beforeAt === '') {
        // 메시지: "Please include '@' in your email address. '{Email 영역에 입력한 텍스트}' is missing."
        const errorText = errorMsg.dataset.emailMissingAt 
          ? errorMsg.dataset.emailMissingAt.replace('{{ email }}', `'${emailValue}'`)
          : `Please include '@' in your email address. '${emailValue}' is missing.`;
        const finalErrorText = `* ${errorText}`;
        console.warn('⚠️ [Password Reset] CASE 2: @ 앞부분 없음 -', finalErrorText);
        errorMsg.innerText = finalErrorText;
        errorMsg.classList.remove('hidden');
        if (formFieldWrapper) formFieldWrapper.classList.add('form-field__wrapper--error');
        return;
      }
      
      // CASE 3: @ 뒷부분을 입력하지 않을 경우 (예: 'test@')
      if (!afterAt || afterAt === '') {
        // 메시지: "Please enter the part after '@'. '{Email 영역에 입력한 텍스트}' is incomplete."
        const errorText = errorMsg.dataset.emailIncompleteAfterAt 
          ? errorMsg.dataset.emailIncompleteAfterAt.replace('{{ email }}', `'${emailValue}'`)
          : `Please enter the part after '@'. '${emailValue}' is incomplete.`;
        const finalErrorText = `* ${errorText}`;
        console.warn('⚠️ [Password Reset] CASE 3: @ 뒷부분 없음 -', finalErrorText);
        errorMsg.innerText = finalErrorText;
        errorMsg.classList.remove('hidden');
        if (formFieldWrapper) formFieldWrapper.classList.add('form-field__wrapper--error');
        return;
      }
      
      // 최종 이메일 형식 검증
      if (!EMAIL_REGEX.test(emailValue)) {
        // 기타 이메일 형식 오류 (예: 'test@test', 'test@test.', 등)
        const errorText = errorMsg.dataset.emailMissingAt 
          ? errorMsg.dataset.emailMissingAt.replace('{{ email }}', `'${emailValue}'`)
          : `Please include '@' in your email address. '${emailValue}' is missing.`;
        const finalErrorText = `* ${errorText}`;
        console.warn('⚠️ [Password Reset] CASE 4: EMAIL_REGEX 실패 -', finalErrorText);
        errorMsg.innerText = finalErrorText;
        errorMsg.classList.remove('hidden');
        if (formFieldWrapper) formFieldWrapper.classList.add('form-field__wrapper--error');
        return;
      }
      
      // 유효성 검사 통과 - 폼 제출
      console.log('✅ [Password Reset] 유효성 검사 통과 - 폼 제출');
      errorMsg.classList.add('hidden');
      if (formFieldWrapper) formFieldWrapper.classList.remove('form-field__wrapper--error');
      const form = resetPasswordWrapper.querySelector('form');
      if (form) {
        // form.requestSubmit()을 사용하면 CSRF 토큰이 포함된 올바른 폼 제출이 됨
        // requestSubmit()은 form의 submit 이벤트를 트리거하므로 validation과 CSRF 토큰이 포함됨
        if (typeof form.requestSubmit === 'function') {
          console.log('📤 [Password Reset] form.requestSubmit() 호출');
          form.requestSubmit();
        } else {
          // 구형 브라우저 fallback: submit 버튼을 생성하여 클릭
          console.log('📤 [Password Reset] fallback: submit 버튼 생성하여 제출');
          const submitButton = document.createElement('button');
          submitButton.type = 'submit';
          submitButton.style.display = 'none';
          form.appendChild(submitButton);
          submitButton.click();
          form.removeChild(submitButton);
        }
      } else {
        console.error('❌ [Password Reset] form 요소를 찾을 수 없습니다');
      }
    });

    this.handleCheckInitEmail();
    this.handleAddFakeBtns();
  }

  handleCheckInitEmail() {
    localStorage.setItem('emailYN', 'N');
  }

  handleAddFakeBtns() {
    const snsLoginBtns = this.querySelector('.h_buttons');
    if (!snsLoginBtns) {
      // Wait for container to appear using MutationObserver
      const containerObserver = new MutationObserver((mutations, obs) => {
        const container = this.querySelector('.h_buttons');
        if (container) {
          obs.disconnect();
          this.initTempButtons(container);
        }
      });
      containerObserver.observe(this, { childList: true, subtree: true });
      return;
    }
    
    this.initTempButtons(snsLoginBtns);
  }

  initTempButtons(snsLoginBtns) {
    // Check if already initialized
    if (snsLoginBtns.dataset.tempButtonsInitialized === 'true') {
      return;
    }
    snsLoginBtns.dataset.tempButtonsInitialized = 'true';

    const tempButtons = new Map(); // realBtn -> tempBtn mapping
    let rafId = null;

    // Update button positions (optimized with requestAnimationFrame)
    const updateButtonPositions = () => {
      if (rafId) cancelAnimationFrame(rafId);
      
      rafId = requestAnimationFrame(() => {
        const containerRect = snsLoginBtns.getBoundingClientRect();
        
        tempButtons.forEach((tempBtn, realBtn) => {
          if (!realBtn.isConnected || !tempBtn.isConnected) {
            tempButtons.delete(realBtn);
            tempBtn.remove();
            return;
          }

          const rect = realBtn.getBoundingClientRect();
          tempBtn.style.top = `${rect.top - containerRect.top + snsLoginBtns.scrollTop}px`;
          tempBtn.style.left = `${rect.left - containerRect.left}px`;
          tempBtn.style.width = `${rect.width}px`;
          tempBtn.style.height = `${rect.height}px`;
        });
      });
    };

    // Create temp button for real button
    const createTempButton = (realBtn) => {
      if (tempButtons.has(realBtn)) return;

      const tempBtn = document.createElement('div');
      tempBtn.className = `${realBtn.className} temp_button`;
      tempBtn.innerHTML = realBtn.innerHTML;
      tempBtn.setAttribute('aria-hidden', 'true');
      tempBtn.setAttribute('tabindex', '-1');
      
      snsLoginBtns.appendChild(tempBtn);
      tempButtons.set(realBtn, tempBtn);
      updateButtonPositions();
    };

    // Process initial buttons
    const realButtons = Array.from(snsLoginBtns.children).filter(btn => 
      !btn.classList.contains('temp_button')
    );
    realButtons.forEach(createTempButton);

    // Event delegation: handle temp button clicks
    snsLoginBtns.addEventListener('click', (e) => {
      const tempBtn = e.target.closest('.temp_button');
      if (!tempBtn || tempBtn.classList.contains('hide_temp_button')) return;

      e.preventDefault();
      e.stopPropagation();
      
      location.href = "#ContactForm-checkbox1";

      const checkbox1 = this.querySelector('#ContactForm-checkbox1');
      const checkbox2 = this.querySelector('#ContactForm-checkbox2');

      if (!checkbox1?.checked) {
        const agreementError = this.querySelector('#agreement')?.querySelector('.form-field__text--error');
        agreementError?.classList.remove('hidden');
      }

      if (!checkbox2?.checked) {
        const privacyError = this.querySelector('#privacy')?.querySelector('.form-field__text--error');
        privacyError?.classList.remove('hidden');
      }
    });

    // MutationObserver: detect button additions/removals
    const buttonObserver = new MutationObserver((mutations) => {
      let needsUpdate = false;

      mutations.forEach(mutation => {
        mutation.addedNodes.forEach(node => {
          if (node.nodeType === 1 && !node.classList.contains('temp_button')) {
            createTempButton(node);
            needsUpdate = true;
          }
        });

        mutation.removedNodes.forEach(node => {
          if (node.nodeType === 1 && tempButtons.has(node)) {
            tempButtons.get(node)?.remove();
            tempButtons.delete(node);
            needsUpdate = true;
          }
        });
      });

      if (needsUpdate) {
        updateButtonPositions();
      }
    });

    buttonObserver.observe(snsLoginBtns, {
      childList: true,
      subtree: false
    });

    // Resize and scroll events (throttled)
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateButtonPositions, 16);
    };

    window.addEventListener('resize', handleResize, { passive: true });
    snsLoginBtns.addEventListener('scroll', updateButtonPositions, { passive: true });

    // Set initial positions
    updateButtonPositions();
  }
})
